class InfoModal extends window.Modal {
  constructor() {
    super()
    this.isLoaded = false
    this.open = this.open.bind(this) // Bind the method
  }

  connectedCallback() {
    // Call base class setup
    super.connectedCallback()

    // Add click listeners to ALL matching triggers
    const triggers = document.querySelectorAll(
      `[data-trigger-modal][aria-controls="${this.id}"]`
    )
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.open)
    })
  }

  disconnectedCallback() {
    // Clean up listeners when element is removed
    const triggers = document.querySelectorAll(
      `[data-trigger-modal][aria-controls="${this.id}"]`
    )
    triggers.forEach((trigger) => {
      trigger.removeEventListener('click', this.open)
    })
    super.disconnectedCallback?.()
  }
}

// Register the custom element
if (!customElements.get('info-modal')) {
  customElements.define('info-modal', InfoModal)
}
